export const getQuantityData = (index, hasCustomOptions, customOptionsItems, hasVolumeDiscount, quantitySelector) => {
  if (hasCustomOptions) {
    return customOptionsItems[index - 1];
  }
  if (hasVolumeDiscount) {
    return quantitySelector?.selector?.template?.volume_discount_options[index - 1];
  }
  return {};
};
